import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useDevtools, useShowDevtools } from '../devtoolsQueries';
import NavSeparator from '../../navbar/components/NavSeparator';
import { SettingsIcon } from 'foundations-assets/icons/components/SettingsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DevtoolsButton = () => {
  const {
    toggle
  } = useDevtools();
  const showDevtools = useShowDevtools();
  if (!showDevtools) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavSeparator, {}), /*#__PURE__*/_jsx(IconButton, {
      onClick: toggle,
      use: "transparent",
      children: /*#__PURE__*/_jsx(SettingsIcon, {
        color: "icon-interactive-on-fill-default"
      })
    })]
  });
};